import React from "react";
import Vehicle from "./Components/Vehicle";
import Equipments from "./Components/Equipments";
import Fahas from "./Components/Fahas";
import Insurance from "./Components/Insurance";
import VehicleStatus from "./Components/VehicleStatus";
import EquipmentStatus from "./Components/EquipmentStatus";

function MaintanaceIndex() {
  return (
    <div className="w-full space-y-4 pb-6">
      {/* Top Stat Cards & Renewal Intelligence Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        {/* Left Stats Column */}
        <div className="lg:col-span-1 flex flex-col sm:flex-row lg:flex-col gap-4">
          <div className="flex-1">
            <Vehicle />
          </div>
          <div className="flex-1">
            <Equipments />
          </div>
        </div>

        {/* Insurance & Fahas Cards */}
        <div className="lg:col-span-2">
          <Insurance />
        </div>
        <div className="lg:col-span-2">
          <Fahas />
        </div>
      </div>

      {/* Fleet & Equipment Operational Breakdown */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <div className="lg:col-span-3">
          <VehicleStatus />
        </div>
        <div className="lg:col-span-2">
          <EquipmentStatus />
        </div>
      </div>
    </div>
  );
}

export default MaintanaceIndex;